import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import MediaIndexPage from '@buyside/components/presentation/MediaIndexPage/mediaIndexPage';
import { MediaTypes } from '@buyside/components/presentation/MediaShowPage/mediaShowPage';

import { videoIndexUrl } from '@buyside/util/urlHelper';

const VideoIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="video index page">
      <Router basename={videoIndexUrl()}>
        <MediaIndexPage mediaType={MediaTypes.VIDEO} />
      </Router>
    </ErrorBoundary>
  );
};

export default VideoIndexPageRoot;
